var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalIconWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 25,
    stroke: "#FF6E65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 34.4C27.4933 34.4 27.0933 34.24 26.8 33.92C26.5333 33.6 26.3733 33.1467 26.32 32.56L25.12 17.28C25.04 16.2933 25.2533 15.5067 25.76 14.92C26.2667 14.3067 27.0133 14 28 14C28.96 14 29.68 14.3067 30.16 14.92C30.6667 15.5067 30.88 16.2933 30.8 17.28L29.6 32.56C29.5733 33.1467 29.4133 33.6 29.12 33.92C28.8533 34.24 28.48 34.4 28 34.4ZM28 42.72C27.0933 42.72 26.36 42.44 25.8 41.88C25.2667 41.32 25 40.6 25 39.72C25 38.8667 25.2667 38.1733 25.8 37.64C26.36 37.08 27.0933 36.8 28 36.8C28.9333 36.8 29.6533 37.08 30.16 37.64C30.6933 38.1733 30.96 38.8667 30.96 39.72C30.96 40.6 30.6933 41.32 30.16 41.88C29.6533 42.44 28.9333 42.72 28 42.72Z",
    fill: "#FF6E65"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconWarning);
export default __webpack_public_path__ + "static/media/ModalIconWarning.a0f2c865bd5b1885eae59fc2c7b13397.svg";
export { ForwardRef as ReactComponent };